var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { Component, L10n, Browser, isBlazor } from '@syncfusion/ej2-base';
import { createElement, compile as templateCompiler } from '@syncfusion/ej2-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { Property, Event, NotifyPropertyChanges } from '@syncfusion/ej2-base';
import { NumericContainer } from './numeric-container';
import { PagerMessage } from './pager-message';
import { appendChildren } from '../grid/base/util';
/**
 * Represents the `Pager` component.
 * ```html
 * <div id="pager"/>
 * ```
 * ```typescript
 * <script>
 *   var pagerObj = new Pager({ totalRecordsCount: 50, pageSize:10 });
 *   pagerObj.appendTo("#pager");
 * </script>
 * ```
 */

var Pager =
/** @class */
function (_super) {
  __extends(Pager, _super);
  /**
   * Constructor for creating the component.
   * @hidden
   */


  function Pager(options, element) {
    var _this = _super.call(this, options, element) || this;
    /** @hidden */


    _this.hasParent = false;
    _this.pageRefresh = 'pager-refresh';
    return _this;
  }
  /**
   * To provide the array of modules needed for component rendering
   * @hidden
   */


  Pager.prototype.requiredModules = function () {
    var modules = [];

    if (this.enableExternalMessage) {
      modules.push({
        member: 'externalMessage',
        args: [this]
      });
    }

    if (this.checkpagesizes()) {
      modules.push({
        member: 'pagerdropdown',
        args: [this]
      });
    }

    return modules;
  };
  /**
   * Initialize the event handler
   * @hidden
   */


  Pager.prototype.preRender = function () {
    //preRender
    this.defaultConstants = {
      currentPageInfo: '{0} of {1} pages',
      totalItemsInfo: '({0} items)',
      totalItemInfo: '({0} item)',
      firstPageTooltip: 'Go to first page',
      lastPageTooltip: 'Go to last page',
      nextPageTooltip: 'Go to next page',
      previousPageTooltip: 'Go to previous page',
      nextPagerTooltip: 'Go to next pager',
      previousPagerTooltip: 'Go to previous pager',
      pagerDropDown: 'Items per page',
      pagerAllDropDown: 'Items',
      CurrentPageInfo: '{0} of {1} pages',
      TotalItemsInfo: '({0} items)',
      FirstPageTooltip: 'Go to first page',
      LastPageTooltip: 'Go to last page',
      NextPageTooltip: 'Go to next page',
      PreviousPageTooltip: 'Go to previous page',
      NextPagerTooltip: 'Go to next pager',
      PreviousPagerTooltip: 'Go to previous pager',
      PagerDropDown: 'Items per page',
      PagerAllDropDown: 'Items',
      All: 'All'
    };
    this.containerModule = new NumericContainer(this);
    this.pagerMessageModule = new PagerMessage(this);
  };
  /**
   * To Initialize the component rendering
   */


  Pager.prototype.render = function () {
    if (this.template) {
      if (this.isReactTemplate()) {
        this.on(this.pageRefresh, this.pagerTemplate, this);
        this.notify(this.pageRefresh, {});
      } else {
        this.pagerTemplate();
      }
    } else {
      this.initLocalization();
      this.updateRTL();
      this.totalRecordsCount = this.totalRecordsCount || 0;
      this.renderFirstPrevDivForDevice();
      this.containerModule.render();

      if (this.enablePagerMessage) {
        this.pagerMessageModule.render();
      }

      this.renderNextLastDivForDevice();

      if (this.checkpagesizes() && this.pagerdropdownModule) {
        this.pagerdropdownModule.render();
      }

      this.addAriaLabel();

      if (this.enableExternalMessage && this.externalMessageModule) {
        this.externalMessageModule.render();
      }

      this.refresh();
      this.trigger('created', {
        'currentPage': this.currentPage,
        'totalRecordsCount': this.totalRecordsCount
      });
    }
  };
  /**
   * Get the properties to be maintained in the persisted state.
   * @hidden
   */


  Pager.prototype.getPersistData = function () {
    var keyEntity = ['currentPage', 'pageSize'];
    return this.addOnPersist(keyEntity);
  };
  /**
   * To destroy the Pager component.
   * @method destroy
   * @return {void}
   */


  Pager.prototype.destroy = function () {
    if (this.isReactTemplate()) {
      this.off(this.pageRefresh, this.pagerTemplate);

      if (!this.hasParent) {
        this.destroyTemplate(['template']);
      }
    }

    _super.prototype.destroy.call(this);

    this.containerModule.destroy();
    this.pagerMessageModule.destroy();

    if (!this.isReactTemplate()) {
      this.element.innerHTML = '';
    }
  };
  /**
   * Destroys the given template reference.
   * @param {string[]} propertyNames - Defines the collection of template name.
   */
  //tslint:disable-next-line:no-any


  Pager.prototype.destroyTemplate = function (propertyNames, index) {
    this.clearTemplate(propertyNames, index);
  };
  /**
   * For internal use only - Get the module name.
   * @private
   */


  Pager.prototype.getModuleName = function () {
    return 'pager';
  };
  /**
   * Called internally if any of the property value changed.
   * @hidden
   */


  Pager.prototype.onPropertyChanged = function (newProp, oldProp) {
    if (this.isDestroyed) {
      return;
    }

    if (newProp.pageCount !== oldProp.pageCount) {
      this.containerModule.refreshNumericLinks();
      this.containerModule.refresh();
    }

    for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
      var prop = _a[_i];

      switch (prop) {
        case 'currentPage':
          if (this.checkGoToPage(newProp.currentPage, oldProp.currentPage)) {
            this.currentPageChanged(newProp, oldProp);
          }

          break;

        case 'pageSize':
        case 'totalRecordsCount':
        case 'customText':
          if (this.checkpagesizes() && this.pagerdropdownModule) {
            if (oldProp.pageSize !== newProp.pageSize) {
              this.currentPage = 1;
            }

            this.pagerdropdownModule.setDropDownValue('value', this.pageSize);
          }

          if (newProp.pageSize !== oldProp.pageSize) {
            this.pageSize = newProp.pageSize;
            this.currentPageChanged(newProp, oldProp);
          } else {
            this.refresh();
          }

          break;

        case 'pageSizes':
          if (this.checkpagesizes() && this.pagerdropdownModule) {
            this.pagerdropdownModule.destroy();
            this.pagerdropdownModule.render();
          }

          this.refresh();
          break;

        case 'template':
          this.templateFn = this.compile(this.template);
          this.refresh();
          break;

        case 'locale':
          this.initLocalization();
          this.refresh();
          break;

        case 'enableExternalMessage':
          if (this.enableExternalMessage && this.externalMessageModule) {
            this.externalMessageModule.render();
          }

          break;

        case 'externalMessage':
          if (this.externalMessageModule) {
            this.externalMessageModule.refresh();
          }

          break;

        case 'enableRtl':
          this.updateRTL();
          break;

        case 'enablePagerMessage':
          if (this.enablePagerMessage) {
            this.pagerMessageModule.showMessage();
          } else {
            this.pagerMessageModule.hideMessage();
          }

          break;
      }
    }
  };
  /**
   * Gets the localized label by locale keyword.
   * @param  {string} key
   * @return {string}
   */


  Pager.prototype.getLocalizedLabel = function (key) {
    return this.localeObj.getConstant(key);
  };
  /**
   * Navigate to target page by given number.
   * @param  {number} pageNo - Defines page number.
   * @return {void}
   */


  Pager.prototype.goToPage = function (pageNo) {
    if (this.checkGoToPage(pageNo)) {
      this.currentPage = pageNo;
      this.dataBind();
    }
  };
  /**
   * @hidden
   */


  Pager.prototype.setPageSize = function (pageSize) {
    this.pageSize = pageSize;
    this.dataBind();
  };

  Pager.prototype.checkpagesizes = function () {
    if (this.pageSizes === true || this.pageSizes.length) {
      return true;
    }

    return false;
  };

  Pager.prototype.checkGoToPage = function (newPageNo, oldPageNo) {
    if (newPageNo !== this.currentPage) {
      this.previousPageNo = this.currentPage;
    }

    if (!isNullOrUndefined(oldPageNo)) {
      this.previousPageNo = oldPageNo;
    }

    if (this.previousPageNo !== newPageNo && newPageNo >= 1 && newPageNo <= this.totalPages) {
      return true;
    }

    return false;
  };

  Pager.prototype.currentPageChanged = function (newProp, oldProp) {
    if (this.enableQueryString) {
      this.updateQueryString(this.currentPage);
    }

    if (newProp.currentPage !== oldProp.currentPage || newProp.pageSize !== oldProp.pageSize) {
      var args = {
        currentPage: this.currentPage,
        newProp: newProp,
        oldProp: oldProp,
        cancel: false
      };
      this.trigger('click', args);

      if (!args.cancel) {
        this.refresh();
      }
    }
  };

  Pager.prototype.pagerTemplate = function () {
    if (this.isReactTemplate() && this.hasParent) {
      return;
    }

    var result;
    this.element.classList.add('e-pagertemplate');
    this.compile(this.template);
    var data = {
      currentPage: this.currentPage,
      pageSize: this.pageSize,
      pageCount: this.pageCount,
      totalRecordsCount: this.totalRecordsCount,
      totalPages: this.totalPages
    };
    var tempId = this.element.parentElement.id + '_template';

    if (this.isReactTemplate()) {
      this.getPagerTemplate()(data, this, 'template', tempId, null, null, this.element);
      this.renderReactTemplates();
    } else {
      result = isBlazor() ? this.getPagerTemplate()(data, this, 'template', tempId, this.isStringTemplate) : this.isVue ? this.getPagerTemplate()(data, this) : this.getPagerTemplate()(data);
      appendChildren(this.element, result);
    }
  };
  /** @hidden */


  Pager.prototype.updateTotalPages = function () {
    this.totalPages = this.totalRecordsCount % this.pageSize === 0 ? this.totalRecordsCount / this.pageSize : parseInt((this.totalRecordsCount / this.pageSize).toString(), 10) + 1;
  };
  /** @hidden */


  Pager.prototype.getPagerTemplate = function () {
    return this.templateFn;
  };
  /** @hidden */


  Pager.prototype.compile = function (template) {
    if (template) {
      var e = void 0;

      try {
        if (document.querySelectorAll(template).length) {
          this.templateFn = templateCompiler(document.querySelector(template).innerHTML.trim());
        }
      } catch (e) {
        this.templateFn = templateCompiler(template);
      }
    }

    return undefined;
  };
  /**
   * Refreshes page count, pager information and external message.
   * @return {void}
   */


  Pager.prototype.refresh = function () {
    if (this.template) {
      if (this.isReactTemplate()) {
        this.updateTotalPages();
        this.notify(this.pageRefresh, {});
      } else {
        this.element.innerHTML = '';
        this.updateTotalPages();
        this.pagerTemplate();
      }
    } else {
      this.updateRTL();
      this.containerModule.refresh();

      if (this.enablePagerMessage) {
        this.pagerMessageModule.refresh();
      }

      if (this.pagerdropdownModule) {
        this.pagerdropdownModule.refresh();
      }

      if (this.enableExternalMessage && this.externalMessageModule) {
        this.externalMessageModule.refresh();
      }
    }
  };

  Pager.prototype.updateRTL = function () {
    if (this.enableRtl) {
      this.element.classList.add('e-rtl');
    } else {
      this.element.classList.remove('e-rtl');
    }
  };

  Pager.prototype.initLocalization = function () {
    this.localeObj = new L10n(this.getModuleName(), this.defaultConstants, this.locale);
  };

  Pager.prototype.updateQueryString = function (value) {
    var updatedUrl = this.getUpdatedURL(window.location.href, 'page', value.toString());
    window.history.pushState({
      path: updatedUrl
    }, '', updatedUrl);
  };

  Pager.prototype.getUpdatedURL = function (uri, key, value) {
    var regx = new RegExp('([?|&])' + key + '=.*?(&|#|$)', 'i');

    if (uri.match(regx)) {
      return uri.replace(regx, '$1' + key + '=' + value + '$2');
    } else {
      var hash = '';

      if (uri.indexOf('#') !== -1) {
        hash = uri.replace(/.*#/, '#');
        uri = uri.replace(/#.*/, '');
      }

      return uri + (uri.indexOf('?') !== -1 ? '&' : '?') + key + '=' + value + hash;
    }
  };

  Pager.prototype.renderFirstPrevDivForDevice = function () {
    this.element.appendChild(createElement('div', {
      className: 'e-mfirst e-icons e-icon-first',
      attrs: {
        title: isBlazor() ? this.getLocalizedLabel('FirstPageTooltip') : this.getLocalizedLabel('firstPageTooltip'),
        tabindex: '-1'
      }
    }));
    this.element.appendChild(createElement('div', {
      className: 'e-mprev e-icons e-icon-prev',
      attrs: {
        title: isBlazor() ? this.getLocalizedLabel('PreviousPageTooltip') : this.getLocalizedLabel('previousPageTooltip'),
        tabindex: '-1'
      }
    }));
  };

  Pager.prototype.renderNextLastDivForDevice = function () {
    this.element.appendChild(createElement('div', {
      className: 'e-mnext e-icons e-icon-next',
      attrs: {
        title: isBlazor() ? this.getLocalizedLabel('NextPageTooltip') : this.getLocalizedLabel('nextPageTooltip'),
        tabindex: '-1'
      }
    }));
    this.element.appendChild(createElement('div', {
      className: 'e-mlast e-icons e-icon-last',
      attrs: {
        title: isBlazor() ? this.getLocalizedLabel('LastPageTooltip') : this.getLocalizedLabel('lastPageTooltip'),
        tabindex: '-1'
      }
    }));
  };

  Pager.prototype.addAriaLabel = function () {
    var classList = ['.e-mfirst', '.e-mprev', '.e-mnext', '.e-mlast'];

    if (!Browser.isDevice) {
      for (var i = 0; i < classList.length; i++) {
        var element = this.element.querySelector(classList[i]);
        element.setAttribute('aria-label', element.getAttribute('title'));
      }
    }
  };

  Pager.prototype.isReactTemplate = function () {
    return this.isReact && this.template && typeof this.template !== 'string';
  };

  __decorate([Property(false)], Pager.prototype, "enableQueryString", void 0);

  __decorate([Property(false)], Pager.prototype, "enableExternalMessage", void 0);

  __decorate([Property(true)], Pager.prototype, "enablePagerMessage", void 0);

  __decorate([Property(12)], Pager.prototype, "pageSize", void 0);

  __decorate([Property(10)], Pager.prototype, "pageCount", void 0);

  __decorate([Property(1)], Pager.prototype, "currentPage", void 0);

  __decorate([Property()], Pager.prototype, "totalRecordsCount", void 0);

  __decorate([Property()], Pager.prototype, "externalMessage", void 0);

  __decorate([Property(false)], Pager.prototype, "pageSizes", void 0);

  __decorate([Property()], Pager.prototype, "template", void 0);

  __decorate([Property('')], Pager.prototype, "customText", void 0);

  __decorate([Event()], Pager.prototype, "click", void 0);

  __decorate([Event()], Pager.prototype, "dropDownChanged", void 0);

  __decorate([Event()], Pager.prototype, "created", void 0);

  Pager = __decorate([NotifyPropertyChanges], Pager);
  return Pager;
}(Component);

export { Pager };